export default __webpack_public_path__ + "e6b1be304ad473f6c12de40509d6fe41.png";